import { Colors, getPrice } from '@sigma-frontend-libs/commons'

import { icons, services } from '@/utils'

import { amountColors, amountIcons } from '@/components/services/billings/utils'
import sticker from '@/components/sticker'

export default function(h) {
  if (this.$value.amount) {
    let icon = icons.wallet
    let color = Colors.primary
    if (this.$value.source) {
      icon = amountIcons[this.$value.source]
      color = amountColors[this.$value.source]
    }

    return h(
      sticker,
      {
        props: {
          value: getPrice(this.$value.amount),
          icon,
          color,
          label: this.getTranslate(`${services.payments}.labels.amount`)
        }
      }
    )
  }
}
